import React from 'react';
import styled, { css } from 'styled-components';

export const IconElement = styled.i`
  color: ${({ theme, color }) => (color ? theme.colors[color] : 'inherit')};
  font-size: ${({ theme, iconSize }) => theme.utils.pxToRem(iconSize)}rem;
  ${({ shadow, shadowOpacity = 0.64 }) =>
    shadow &&
    css`
      text-shadow: 0px 0px 2px rgba(0, 0, 0, ${shadowOpacity});
    `}
  &.fa-equal:before {
    content: '=';
    font-size: 1.5em;
    font-weight: bold;
  }
  &.hover-icon {
    line-height: ${({ iconSize, theme }) => theme.utils.pxToRem(iconSize)}rem;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme, borderColor, containerColor, borderWidth, size = 24 }) =>
    css`
      border: ${borderWidth}px solid ${theme.colors[borderColor]};
      min-width: ${theme.utils.pxToRem(size)}rem;
      height: ${theme.utils.pxToRem(size)}rem;
      background-color: ${theme.colors[containerColor]};
    `}
  ${({ theme, containerType, cornerRadius, size = 24 }) => {
    if (containerType === 'circle') {
      return css`
        border-radius: ${theme.utils.pxToRem(size / 2)}rem;
      `;
    }
    return css`
      border-radius: ${theme.utils.pxToRem(cornerRadius)}rem;
    `;
  }}
`;

const Circle = styled.div`
  width: ${({ theme, iconSize }) => theme.utils.pxToRem(iconSize)}rem;
  height: ${({ theme, iconSize }) => theme.utils.pxToRem(iconSize)}rem;
  background-color: ${({ theme, color }) =>
    color ? theme.colors[color] : 'inherit'};
  border-radius: 50%;
`;

const Icon = (props) => {
  const {
    icon,
    containerType,
    cornerRadius = 0,
    borderWidth = 1,
    borderColor = 'black',
    containerColor = 'white',
    iconSize = 16,
    size,
    opacity,
    ...rest
  } = props;

  const family = props.family || 'hover';

  const fontClasses =
    family === 'fontAwesome' ? `fa fa-${icon}` : `hover-icon hover-${icon}`;

  const iconEle =
    icon === 'circle' ? (
      <Circle {...rest} iconSize={iconSize} />
    ) : (
      <IconElement
        {...rest}
        iconSize={iconSize}
        className={[rest.className, fontClasses].join(' ')}
      />
    );

  if (containerType) {
    return (
      <Container
        size={size}
        containerType={containerType}
        cornerRadius={cornerRadius}
        borderColor={borderColor}
        containerColor={containerColor}
        borderWidth={borderWidth}
        opacity={opacity}
      >
        {iconEle}
      </Container>
    );
  }

  return iconEle;
};

export default Icon;
